import { useCallback } from 'react';
import { SelectOption, SelectValue } from '../../../../../../../tailwindComponents/selectTW/interfaces';
import {
  eCreateSigningAppointmentFormDataOwnerTypes,
  isDigitalSchedulingOwnerType,
} from '../../../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';
import { useFormikContext } from 'formik';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { getDefaultSigningTypeFromAppointmentType } from '../utilities/getDefaultSigningTypeFromAppointmentType';
import { useSelectCurrentOrder } from '../../../../../../../selectors/order/selectCurrentOrder';
import { eSigningMethod } from 'types/documents/eSigningMethod';
import { eTransactionCategory } from '../../../../../../../ui-toolkit/enums/eTransactionType';

const assertValueIsOwnerType = (value: SelectValue): value is eCreateSigningAppointmentFormDataOwnerTypes => {
  return Object.values(eCreateSigningAppointmentFormDataOwnerTypes).some((consumerType) => consumerType === value);
};

const setDefaultSigningTypeFromAppointmentType = ({
  setFieldValue,
  ownerType,
  transactionCategory,
}: {
  setFieldValue: (field: keyof IDetailsFormData, value: string) => void;
  ownerType: SelectValue;
  transactionCategory: eTransactionCategory;
}) => {
  if (!assertValueIsOwnerType(ownerType)) {
    throw new Error('This ownerType is not recognized');
  }
  setFieldValue('signingType', getDefaultSigningTypeFromAppointmentType(ownerType, transactionCategory));
};

export const useOnChangeOwnerType = () => {
  const { data: order } = useSelectCurrentOrder();
  const { setFieldValue } = useFormikContext<IDetailsFormData>();

  return useCallback(
    ({ value }: SelectOption) => {
      if (value) {
        const isDigitalSchedulingOwnerTypeValue = isDigitalSchedulingOwnerType(value);
        setFieldValue('isDigitalScheduling', isDigitalSchedulingOwnerTypeValue);
        setFieldValue('signerWillProvideLocation', isDigitalSchedulingOwnerTypeValue);
        setFieldValue('signerSelectsFromRange', isDigitalSchedulingOwnerTypeValue);
        setFieldValue('signingMethod', eSigningMethod.Notary);
      }

      setDefaultSigningTypeFromAppointmentType({
        setFieldValue,
        ownerType: value,
        transactionCategory: order.transaction.transaction_category,
      });
    },
    [setFieldValue, order]
  );
};
